import { Box, Button, Card, InlineStack,Badge, BlockStack, Icon, Tooltip } from '@shopify/polaris';
import { QuestionCircleIcon } from '@shopify/polaris-icons';
import React from 'react';

const FeatureList = ({importQuotaList,handleQuotaBuy})=> {
    
    
    return (
        <Box>
            <Box className="new_sub_module_title">
            <InlineStack gap={100} blockAlign='center'>
            <span >Product Import Quota</span>
            <Tooltip content="Valid for importing products from Dropshipman, AliExpress, and Temu.">
            <span><Icon
                source={QuestionCircleIcon}
                tone="base"
            /></span>
            </Tooltip></InlineStack></Box>
            <Box className="new_sub_sorcing_quota_list">
                {importQuotaList.map((item,ind)=><Box key={ind}>
                    <Card>
                      <BlockStack gap={200}>
                        <Box><Badge tone="info">{item.num} {item.badge}</Badge></Box>
                        <Box>
                           <InlineStack gap={100} blockAlign='baseline'>
                            <Box style={{fontSize:20,fontWeight:650}}>${item.money}</Box>
                            <span style={{color:'rgba(118, 118, 118, 1)'}}>USD</span>
                            </InlineStack>
                        </Box>
                        <Box>${item.money / item.num} {item.desc}</Box>
                        <Box><Button loading={item.loading} disabled={item.disabled} onClick={()=>handleQuotaBuy(item.key,1)}>{item.button}</Button></Box>
                        </BlockStack>
                    </Card>
                </Box>)}
            </Box>
        </Box>
    );
}

export default FeatureList;
